import { z } from "zod";
import { evaluationSchema } from "./Evaluation";

export const regularQuestionSchema = z.object({
  id: z.string(),
  type: z.literal("regular"),
  content: z.string(),
  isEdit: z.boolean(),
  perfectScore: z.coerce.number().min(1, "Perfect score must be at least 1."),
  evaluations: z.array(evaluationSchema).superRefine((evaluations, ctx) => {
    const weight = evaluations.reduce(
      (sum, question) => sum + Math.floor(question.weight * 10),
      0,
    );
    if (weight !== 10) {
      const remaining = ((10 - weight) / 10).toFixed(1);
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `Weight of evaluations must add up to “1.0”. Weight points remaining to distribute: “${remaining}”.`,
      });
    }
  }),
  sdgs: z.array(z.coerce.number()),
});

export type RegularQuestion = z.infer<typeof regularQuestionSchema>;
